import { render, staticRenderFns } from "./InputTipeBarang.vue?vue&type=template&id=0501919b&"
import script from "./InputTipeBarang.vue?vue&type=script&lang=js&"
export * from "./InputTipeBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports